export default "__VITE_ASSET__DoAEIGEF__"